import { FC } from "react";
import { Box, AspectRatio } from "@radix-ui/themes";

interface CarouselSlideProps {
  activeSlide: any;
  prevSlide: any;
  isTransitioning: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

export const CarouselSlide: FC<CarouselSlideProps> = ({
  activeSlide,
  prevSlide,
  isTransitioning,
  isMobile,
  isTablet,
}) => {
  return (
    <>
      {/* Previous slide (for transition) */}
      {isTransitioning && (
        <Box
          position="absolute"
          inset="0"
          style={{
            zIndex: 1,
            animation: "fadeOut 500ms ease-out forwards",
          }}
        >
          <AspectRatio ratio={isMobile ? 4 / 6 : isTablet ? 4 / 3 : 9 / 4}>
            <img
              src={prevSlide.coverURL}
              alt={prevSlide.alt}
              style={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
            />
          </AspectRatio>
        </Box>
      )}

      {/* Active slide */}
      <AspectRatio ratio={isMobile ? 4 / 6 : isTablet ? 4 / 3 : 9 / 4}>
        <img
          src={activeSlide.coverURL}
          alt={activeSlide.alt}
          style={{
            objectFit: "cover",
            width: "100%",
            height: "100%",
            animation: isTransitioning
              ? "fadeIn 500ms ease-in forwards"
              : "none",
          }}
        />
      </AspectRatio>
    </>
  );
};
